export const reportGenerationParams = {
  prefix: 'global-trx',
  url: '/v2/console/report/',
  types: ['csv']
}
